export const formatPercent = (value) => (value == null ? "—" : `${Math.round(value)}%`);
export const formatMetres = (value) => (value == null ? "—" : `${Number(value).toFixed(2)} m`);
export const formatLitres = (value) => (value == null ? "—" : `${Math.round(value).toLocaleString()} L`);

export function timeAgo(timestamp) {
  if (!timestamp) return "never";
  const seconds = Math.round((Date.now() - new Date(timestamp).getTime()) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} h ago`;
  return `${Math.floor(seconds / 86400)} d ago`;
}

export function formatDateTime(timestamp) {
  if (!timestamp) return "—";
  return new Date(timestamp).toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
}

export function signalLabel(rssi) {
  if (rssi == null) return { label: "—", bars: 0 };
  if (rssi >= -70) return { label: "Strong", bars: 4 };
  if (rssi >= -85) return { label: "Good", bars: 3 };
  if (rssi >= -100) return { label: "Fair", bars: 2 };
  return { label: "Weak", bars: 1 };
}

// Status of a tank in priority order. Always shown with an icon + label.
export function tankStatus(tank) {
  if (!tank.online) return { key: "danger", icon: "ti ti-wifi-off", label: "Offline" };
  const pct = tank.last?.pct;
  if (pct != null && tank.lowPct != null && pct <= tank.lowPct) return { key: "danger", icon: "ti ti-arrow-down", label: "Low" };
  if (pct != null && tank.highPct != null && pct >= tank.highPct) return { key: "warning", icon: "ti ti-arrow-up", label: "High" };
  if (tank.last?.battery != null && tank.batteryLowPct != null && tank.last.battery <= tank.batteryLowPct) {
    return { key: "warning", icon: "ti ti-battery-1", label: "Battery low" };
  }
  return { key: "success", icon: "ti ti-check", label: "Normal" };
}

export const ALERT_LABELS = {
  LOW_LEVEL: "Low level",
  HIGH_LEVEL: "High level",
  LOW_BATTERY: "Low battery",
  OFFLINE: "Offline",
};

export const ALERT_BADGES = {
  LOW_LEVEL: "danger",
  HIGH_LEVEL: "warning",
  LOW_BATTERY: "warning",
  OFFLINE: "danger",
};
